import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/default-page-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`storyfolio`}</h1>
    <p>{`Learning from the `}<a parentName="p" {...{
        "href": "communities"
      }}>{`people`}</a>{` I work with and turning ideas into tangible `}<a parentName="p" {...{
        "href": "mahacks"
      }}>{`projects`}</a>{` is central of what `}<a className="external" href="https://katmh.com">{`I`}</a>{` do.`}</p>
    <p>{`But often the world only sees the results, not the `}<a parentName="p" {...{
        "href": "languages"
      }}>{`processes`}</a>{` of `}<a parentName="p" {...{
        "href": "code"
      }}>{`learning`}</a>{` and growth. We celebrate or `}<a parentName="p" {...{
        "href": "leadership"
      }}>{`criticize`}</a>{` where people have gotten, with little knowledge of how they got there.`}</p>
    <p>{`What if we `}<a parentName="p" {...{
        "href": "choose"
      }}>{`chose`}</a>{` to share the stories behind the outcomes more often?`}</p>
    <hr />
    <p><a parentName="p" {...{
        "href": "all"
      }}>{`list of all pages`}</a></p>
    <p><a parentName="p" {...{
        "href": "meta"
      }}>{`about this project`}</a></p>
    <p><a parentName="p" {...{
        "href": "thanks"
      }}>{`acknowledgements`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      